import config from "./config"
import { useNavigate } from "react-router-dom"
import { useCallback, useMemo } from "react"

export interface GoToUnenrolledFormPageData {
  address: string
  unit: string
}

export const useHistoryActions = () => {
  const navigate = useNavigate()

  const goToLandingPage = useCallback(() => {
    navigate(config.landingPath)
  }, [navigate])

  const goToSignUpPage = useCallback((email?: string) => {
    window.location.href = `${config.signupPath}?email=${email ?? ""}`
  }, [])

  const goToUnenrolledFormPage = useCallback(
    (data: GoToUnenrolledFormPageData) => {
      navigate(config.unenrolledBuildingPath, {
        state: data,
      })
    },
    [navigate]
  )

  return useMemo(() => {
    return {
      goToLandingPage,
      goToSignUpPage,
      goToUnenrolledFormPage,
    }
  }, [goToLandingPage, goToSignUpPage, goToUnenrolledFormPage])
}
